import Component from '../classes/Component';

export default function () {

	return new Component({
		name: 'scrollbar',
		requiredTargets: '[data-simplebar]',
        onCreate() {
            this.plugin = null;
        },
		onInit() {
            import(/* webpackChunkName: "simplebar" */ 'simplebar')
                .then(({default: Simplebar}) => {

                    this.plugin = Simplebar;
                })
        },
		onDestroy() {
            this.plugin = null;
        }
	})
}
